import {Component, Input, OnInit} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {ListItem} from "../../../objects/listItem";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {SharedDataService} from "../../../services/shared-data.service";
import {FS3Notification} from "../../../objects/notification";

/**
 * DEPRECATED component. Use UserDraggerPopup instead
 * */
@Component({
  selector: 'app-share-picker',
  templateUrl: './share-picker.component.html',
  styleUrls: ['./share-picker.component.css']
})
export class SharePickerComponent implements OnInit {

  @Input() application: AppComponent;
  private _listItems: ListItem[];
  public get listItems(): ListItem[] {
    return this._listItems;
  }
  @Input() public set listItems(value: ListItem[]) {
    this._listItems = value;
  }
  @Input() state: string;
  @Input() payload: object;

  pickFrom: ListItem[] = [];
  pickTo: ListItem[] = [];

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.application.apiService.getClients('/', this.application.user.magic_key)
      .subscribe(
        data => this.handleItems(data),
        error => this.handleItemsError(error))
  }

  private handleItems(items) {
    items.map(item => {
      let usage: object[];
      let courseUsage: boolean = false;
      if(item['itemFullData']['magic_key'] === this.application.user.magic_key) { //self skip
      // if(item['itemFullData']['magic_key'] === 'F7E3F98A-1D15-2AF3-86FC-CF6A26242BF4') { //self skip
        return;
      }
      if(item['itemFullData']['usage']) {
        usage = JSON.parse(item['itemFullData']['usage']);
        usage.map(val => {
          if(val['name'] == 'courses' && val['items'] && val['items'].indexOf(this.payload['folderUUID']) !== -1) {
            courseUsage = true;
          }
        })
      }
      courseUsage ? this.pickTo.push(item) : this.pickFrom.push(item);
    });
    //this.isItemsLoaded = true;
  }

  private handleItemsError({ errMsg, exception: { status } }) {
    if (errMsg) {
      this.sharedDataService.pushNotification({ text: errMsg, type: 'error' })
    }
    //this.isItemsLoaded = true;
  }

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      let item_magic_key = event.container.data[event.currentIndex]['itemFullData']['magic_key'];
      let action = event.container.id === 'cdk-drop-list-1' ? 'add' : 'remove';
      this.saveItem(item_magic_key,action);
    }
  }

  saveItem(item_magic_key,action) {
    this.application.apiService
      .shareCourse(item_magic_key,action,this.payload['folderUUID'])
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Updated';
          this.sharedDataService.pushNotification(notification);
        },
        error => {
          const { exception } = error;
          if (exception) {
            let msg = (exception.error && exception.error.message) ? exception.error.message : '';
            msg = (!msg && exception.statusText) ? exception.status+' '+exception.statusText : '';
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = msg;
            this.sharedDataService.pushNotification(notification);
          } else {
            //maybe close dialog
          }
        }
      )
  }

}
